import SidebarTitle from "../sidebar-title";

const Appointment = () => {
    return (
        <div className="widget-item">
            <div className="widget-appointment-form">
                <SidebarTitle classOption="title" title="예약 안내" />
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group mb-0">
                            <a
                                href="https://m.booking.naver.com/booking/13/bizes/1581590?theme=place&service-target=map-pc&lang=ko"
                                className="btn btn-theme"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textDecoration: "none",
                                    width: "100%",
                                    backgroundColor: "#03C75A",
                                    color: "#fff",
                                    borderColor: "#03C75A",
                                    fontWeight: "bold"
                                }}
                            >
                                <span style={{ marginRight: "8px", fontWeight: "900" }}>N</span>
                                네이버 예약하기
                            </a>
                            <p style={{ fontSize: "12px", color: "#666", marginTop: "10px", lineHeight: "1.5" }}>
                                * 시술 상담 전용 예약입니다.<br />
                                * 일반 진료는 현장 접수만 가능합니다.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Appointment;
